import {} from "react";
import { useTypyZdroje } from "b2b/api/hooks";

export default function useZdrojeTabs() {
  const { data: typyZdroju, loading } = useTypyZdroje();
  return { typyZdroju, loading };
}
